import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xwg3rhcf7n: FaireBrandEntity = {
  token: "b_xwg3rhcf7n",
  type: "brand",
  name: "ShangDaili",
  avatarUrl:
    "https://cdn.faire.com/fastly/5cbe7d414e5440d46e53c87a8facfad8a4efb3e83f639fdf107f5d3ea54f8808.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/998c6ee028e6b8e4129c0d116d1c5c315ebd69c7bbd637ba6dc80b15f3302714.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5cbe7d414e5440d46e53c87a8facfad8a4efb3e83f639fdf107f5d3ea54f8808.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/998c6ee028e6b8e4129c0d116d1c5c315ebd69c7bbd637ba6dc80b15f3302714.jpeg",
  location: "Santa monica, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 10,
  isInsider: true,
  description:
    "As a self-taught artist with a background in physics, Daili Shang's journey embodies a deep commitment to self-exploration and living authentically. She is dedicated to inspiring others to be true to themselves and to live the life they envision. Daili believes in the possibility of finding happiness and fulfillment in doing what one loves. Through her own transformative path, she hopes to encourage and inspire those who share a similar journey.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:06.704Z",
    importedBy: "entity-db-cli",
  },
};
